export default "__VITE_ASSET__xkRioYPQ__"